import script from "./TitlePrintForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TitlePrintForm.vue?vue&type=script&setup=true&lang=js"

import "./TitlePrintForm.vue?vue&type=style&index=0&id=87feda78&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87feda78"]])

export default __exports__